import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "كم باقي على عيد الاضحى 2026 العد التنازلي لعيد الاضحى 2026";
const DESCRIPTION = "كم باقي على العيد، عيد الاضحى 2026، متى العيد، كم باقي للعيد، متى العيد 2026، تاريخ عيد الأضحى 2026، موعد عيد الأضحى 2026، كم باقي على العيد 2026، عيد الاضحى ٢٠٢٤، كم باقي على عيد الاضحى، كم باقي يوم على العيد، العيد الاضحى 2026، عيد اضحى 2026، كم باقي على العيد الاضحى 2026، العيد الكبير 2026، موعد عيد الاضحى ٢٠٢٤، تاريخ العيد، كم باقي على يوم عرفه, متى عيد الاضحى, متى تكون وقفة يوم عرفة 2026, موعد عيد الاضحى, كم يوم باقي لعيد الاضحى, عيد الأضحى,تاريخ عيد الاضحى, العيد الاضحى,  عيد الاضحي, كم باقي على عيد الاضحى, عيد الأضحى, عيد الاضحى 2026, عيد الاضحى 1444 هجري, كم باقي على عيد الاضحى 2026, كم باقي لعيد الاضحى, كم باقي لعيد الاضحى 2026, موعد عيد الاضحى 2026, عيد الاضحى المبارك, عيد الاضحى، تاريخ عيد الاضحى 2026، كم باقي لعيد الاضحى، كم باقي على العيد الاضحى، كم باقي للعيد، العيد الاضحى 2026";
const KEYWORDS = "كم باقي على العيد، عيد الاضحى 2026، متى العيد، كم باقي للعيد، متى العيد 2026، تاريخ عيد الأضحى 2026، موعد عيد الأضحى 2026، كم باقي على العيد 2026، عيد الاضحى ٢٠٢٤، كم باقي على عيد الاضحى، كم باقي يوم على العيد، العيد الاضحى 2026، عيد اضحى 2026، كم باقي على العيد الاضحى 2026، العيد الكبير 2026، موعد عيد الاضحى ٢٠٢٤، تاريخ العيد، كم باقي على يوم عرفه, متى عيد الاضحى, متى تكون وقفة يوم عرفة 2026, موعد عيد الاضحى, كم يوم باقي لعيد الاضحى, عيد الأضحى,تاريخ عيد الاضحى, العيد الاضحى,  عيد الاضحي, كم باقي على عيد الاضحى, عيد الأضحى, عيد الاضحى 2026, عيد الاضحى 1444 هجري, كم باقي على عيد الاضحى 2026, كم باقي لعيد الاضحى, كم باقي لعيد الاضحى 2026, موعد عيد الاضحى 2026, عيد الاضحى المبارك, عيد الاضحى، تاريخ عيد الاضحى 2026، كم باقي لعيد الاضحى، كم باقي على العيد الاضحى، كم باقي للعيد، العيد الاضحى 2026";
const OG_URL = "https://do-calculate.com/articles-ar/eid-adha";
function EidAdha() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2026-05-27T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const ramadanDates = [
        { name: 'عيد الاضحى 2026', date: new Date("2026-05-27T00:00:00") },
        { name: 'عيد الاضحى 2027', date: new Date("2027-05-17T00:00:00") },
        { name: 'عيد الاضحى 2028', date: new Date("2028-05-05T00:00:00") },
        { name: 'عيد الاضحى 2029', date: new Date("2029-04-24T00:00:00") }
    ];
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على عيد الاضحى 2026
            </h1>
            <div>
                <BlinkingText text="كم باقي على عيد الاضحى: من المتوقع أن يبدأ عيد الاضحى 2026 يوم السبت بتاريخ 27/05/2026 ميلادي و 10/12/1446 بحسب التقويم الهجري." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                                        <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header"  >يوم</th>
                                <th className="bmi-header" >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days" >{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes" >{timeLeft.minutes}</td>
                                <td id="seconds" >{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد عيد الاضحى القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>موعد عيد الاضحى</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>التاريخ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>كم باقي على عيد الاضحى 2026</h3>
                    <p>
                        في هذا المقال، نقدم لكم العد التنازلي المفصل ل عيد الاضحى المبارك، لتكونوا على اطلاع دائم بكم يوم باقٍ على وصول هذا ال الفضيل.الكثير منا يتسائلون كم باقي على  عيد الاضحى المبارك، لهذا نقدم لكم في هذا المقال العد التنازلي ل عيد الاضحى المبارك لتتكمنوا من معرفة كم باقي على عيد الاضحى، كم باقي ع عيد الاضحى، كم يوم باقي على عيد الاضحى شاهدوا العد التنازلي عيد الاضحى المبارك في الأعلى.
                    </p>
                    <p>
                        وفقا لموقع <a href='/calculator/ar/gregorian_to_hijri/'>تحويل التاريخ</a> يصادف عيد الاضحى 2026 يوم السبت  27/05/2026 ميلادي و 10/12/1446 هجري، يمكنكم مشاهدة العد التنازلي لعيد الاضحى 2026 في هذا المقال.
                    </p>
                    <p>تجدون هنا العد التنازلي لعيد الاضحى، حيث يمكنكم معرفة كم باقي يوم على عيد الاضحى الكريم.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        احسب كم باقي لعيد الاضحى الكريم
                    </h3 >
                    <p>
                        من خلال برنامج حساب العد التنازلي لعيد الاضحى يمكنكم معرفة كم باقي لعيد الاضحى بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على عيد الاضحى كم يوم، وكم تبقى لعيد الاضحى، كم تبقي لعيد الاضحى بالأيام, ومتى عيد الاضحى العد التنازلي، باقي على عيد الاضحى، كم تبقى على عيد الاضحى، كم باقي ع عيد الاضحى، باقي كم يوم على عيد الاضحى، كم باقي عن عيد الاضحى، كم تبقى لعيد الاضحى، كم متبقي على عيد الاضحى، كم يوم باقي لعيد الاضحى، كم يوم على عيد الاضحى، كم بقي على عيد الاضحى، كم باقي على  عيد الاضحى، باقى كام يوم على عيد الاضحى،  وموعد عيد الاضحى المبارك لهذه السنة، كل عام وانتم بخير وأعاده ال له علينا وعليكم باليمن والبركات.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        عيد الاضحى
                    </h3>
                    <p>
                        عيد الأضحى هو أحد العيدين عند المسلمين (والعيد الآخر هو عيد الفطر)، يوافق يوم 10 ذو الحجة بعد انتهاء وقفة يوم عرفة، الموقف الذي يقف فيه الحجاج المسلمون لتأدية أهم مناسك الحج، وينتهي يوم 13 ذو الحجة.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="كم باقي على  عيد الاضحى"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        مظاهر احتفال المسلمين بعيد الأضحى المبارك
                    </h3>
                    <p>
                        وفي عيد الأضحى يؤدي المسلمون في كل بقاع العالم شعائر دينية ومناسك محددة، وتشيع أفراحنا ونزور أرحامنا وأحبابنا ويغني أغنياؤنا فقراءنا في هذا اليوم العظيم. وأيام العيد تكون من يوم العاشر من ذي الحجة إلى يوم الثالث عشر من الشهر نفسه.
                    </p>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default EidAdha;